// F11 (DA-BUG-1040): find image URLs that do not load, by asking the browser to load each one.
// A URL that neither loads nor fails within the timeout counts as loaded (fail safe: never block a
// publish on a slow CDN). Without an Image constructor (tests / SSR) nothing is reported.
export function probeImages(urls: string[], timeoutMs = 6000): Promise<string[]> {
  const Img: any = typeof Image === "function" ? Image : (globalThis as any).Image;
  if (typeof Img !== "function") return Promise.resolve([]);
  const unique = Array.from(new Set((urls || []).filter((u) => typeof u === "string" && u.trim())));
  return Promise.all(unique.map((u) => new Promise<string | null>((resolve) => {
    let done = false;
    const finish = (bad: boolean) => { if (!done) { done = true; resolve(bad ? u : null); } };
    const img = new Img();
    img.onload = () => finish(false);
    img.onerror = () => finish(true);
    setTimeout(() => finish(false), timeoutMs);
    img.src = u;
  }))).then((r) => r.filter((x): x is string => !!x));
}

// P7 (DA-BUG-1385): find video URLs that do not load, using a <video> element — an Image() probe
// false-positives on every video, and a fetch/HEAD hits CORS. Same fail-safe as probeImages: a URL
// that neither loads its metadata nor errors within the timeout counts as loaded, so a slow CDN
// never blocks publish. Without a document (tests / SSR) nothing is reported.
export function probeVideos(urls: string[], timeoutMs = 8000): Promise<string[]> {
  const doc: any = typeof document !== "undefined" ? document : null;
  if (!doc || typeof doc.createElement !== "function") return Promise.resolve([]);
  const unique = Array.from(new Set((urls || []).filter((u) => typeof u === "string" && u.trim())));
  return Promise.all(unique.map((u) => new Promise<string | null>((resolve) => {
    let done = false;
    const v: any = doc.createElement("video");
    const finish = (bad: boolean) => { if (!done) { done = true; try { v.src = ""; v.removeAttribute("src"); } catch { /* noop */ } resolve(bad ? u : null); } };
    v.preload = "metadata";
    v.muted = true;
    v.onloadedmetadata = () => finish(false);
    v.oncanplay = () => finish(false);
    v.onerror = () => finish(true);
    setTimeout(() => finish(false), timeoutMs);
    v.src = u;
  }))).then((r) => r.filter((x): x is string => !!x));
}
